import { initWidget } from './loader.js';

// currentScript csak szinkron betöltéskor érvényes — async init előtt elmentjük.
const embedScript = document.currentScript;

window.__chatbotInitWidget = initWidget;

initWidget(embedScript);
